module.exports = __webpack_public_path__ + "static/img/d06bf69d1f9763fd73552f63e3a5161.2378b94c.jpg";